module.exports = __webpack_public_path__ + "static/img/Download_on_the_App_Store_Badge_AR_RGB_blk.svg.848a44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Download_on_the_App_Store_Badge_AR_RGB_blk.svg.png
// module id = 1277
// module chunks = 173